import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React from 'react';
import cx from 'classnames';
import { observer } from 'mobx-react';
import ContentLoading from '../../../components/ContentLoading';
import ContentError from '../../../components/ContentError';
import PayoutMethodItem from './PayoutMethodItem';
import EmptyState from '../../../components/EmptyState';
import ConfirmDialog from '../../../components/ConfirmDialog';
import styles from './PayoutMethods.m.sass';
var BillingMethods = /*#__PURE__*/function (_React$Component) {
  function BillingMethods() {
    _classCallCheck(this, BillingMethods);
    return _callSuper(this, BillingMethods, arguments);
  }
  _inherits(BillingMethods, _React$Component);
  return _createClass(BillingMethods, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var team = this.props.team;
      this.props.billingStore.activate({
        teamId: team ? team.id : null
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        billingStore = _this$props.billingStore,
        team = _this$props.team,
        onMethodClick = _this$props.onMethodClick,
        allowEdit = _this$props.allowEdit;
      var emptyState = /*#__PURE__*/React.createElement(EmptyState, {
        title: "No payout methods."
      });
      return /*#__PURE__*/React.createElement("div", {
        className: cx(styles.root)
      }, billingStore.activate.match({
        pending: function pending() {
          return /*#__PURE__*/React.createElement(ContentLoading, {
            small: true
          });
        },
        rejected: function rejected(err) {
          return /*#__PURE__*/React.createElement(ContentError, {
            error: err
          });
        },
        resolved: function resolved() {
          var profile = team ? billingStore.teamBillingProfile(team.id) : billingStore.individualBillingProfile;
          var methods = profile ? profile.payoutMethods.slice() : [];
          return /*#__PURE__*/React.createElement(React.Fragment, null, methods.length === 0 ? emptyState : methods.map(function (method) {
            return /*#__PURE__*/React.createElement(PayoutMethodItem, {
              key: method.id,
              method: method,
              allowEdit: allowEdit,
              billingStore: billingStore,
              onClick: function onClick() {
                return onMethodClick(method);
              }
            });
          }), /*#__PURE__*/React.createElement("div", {
            className: styles.filler
          }));
        }
      }), /*#__PURE__*/React.createElement(ConfirmDialog, {
        position: "top",
        state: billingStore.deletePayoutMethodDialog,
        danger: true,
        yes: "Delete Payout Method"
      }, "Are you sure you want to delete this payout method?"));
    }
  }]);
}(React.Component);
export default observer(BillingMethods);
//# sourceMappingURL=index.js.map
